import { type CardContentsComponent } from 'components/CardLayoutEditor/models/types';
import React from 'react';

const PrefixContents: React.FC<CardContentsComponent<'prefix'>> = ({
  prefix,
}) => {
  return (
    <span className='tw-font-bold tw-italic tw-mr-1 tw-text-sm tw-text-tertiary'>
      {prefix}
    </span>
  );
};

export default PrefixContents;
